const { host } = window.location;

export const environment = {
    production: false,
    hmr: false,
    stage: true,
    baseApiUrl: `https://${host}/api/`,
    baseGraphQlUrl: `https://${host}/graphql`,
    notificationsApiUrl: `https://${host}/notifications/`,
    authApiUrl: `https://${host}/auth`,
};